import { Layout } from 'antd';
import * as React from 'react';
import type { ReactNode } from 'react';
import { BotProvider } from '../providers/bot-provider';
import { AppProvider } from '../providers/app-provider';
import { ThemeProvider } from '../providers/theme-provider';
import { TrpcProvider } from '../providers/trpc-provider';
import { ConnectionProvider } from '../providers/connection-provider';
import { LocaleSyncManager } from '../components/locale-sync-manager';

export function BotLayout({ children }: { children: ReactNode }) {
  const { Content } = Layout;

  return (
    <ConnectionProvider>
      <TrpcProvider>
        <LocaleSyncManager />
        <ThemeProvider>
          <AppProvider>
            <BotProvider>
              <Layout className="v-grid-mf main" style={{ height: '100vh' }}>
                <Content className="v-grid">{children}</Content>
              </Layout>
            </BotProvider>
          </AppProvider>
        </ThemeProvider>
      </TrpcProvider>
    </ConnectionProvider>
  );
}
